

export class UserJsonDTO {
  email?: string;
  userName? : string;
  firstName?: string;
  lastName?: string;
  taxId?: string;
  roles?: string[] = [];
  }